export default class Previewer {
  constructor(previewButtonSelector, previewContainerSelector, previewModalSelector) {
    this.previewButtonSelector    = previewButtonSelector;
    this.previewContainerSelector = previewContainerSelector;
    this.previewModalSelector     = previewModalSelector;
    this.previewButtonNode        = $(previewButtonSelector);
    this.previewModalNode         = $(previewModalSelector);
  }

  bindPreviewButton() {
    this.previewButtonNode.on('click', function(e) {
      e.preventDefault();

      this.preparePlayer(e.target);
      this.load();
    }.bind(this));
  }

  preparePlayer(target) {
    let $previewContainer = $(this.previewContainerSelector);

    for(let i=0; i<$previewContainer.length; i++){
      let containerDataId = $previewContainer[i].getAttribute("data-video-id");
      let linkDataId = target.getAttribute("data-video-id");

      if(containerDataId == linkDataId){
        this.containerContent = $previewContainer[i];
      }
    }

    this.playerNode = this.containerContent.cloneNode(true);
    this.playerParentNode = this.containerContent.parentElement;

    this.previewModalNode.find('.modal-body').html(this.playerNode);
    this.previewModalNode.find('.modal-title').html(this.containerContent.getAttribute("data-title"));

    this.playerParentNode.removeChild(this.containerContent);

    this.previewModalNode.modal();
    this.playerNode.style.display = "block";
    this.bindModalCose();

    $('#modal').on('hidden.bs.modal', function () {
      this.playerNode.style.display = "none";
      this.playerParentNode.appendChild(this.playerNode);
    }.bind(this));
  }

  bindModalCose(){
    var modalCloseButton = document.querySelector("button.close");
    modalCloseButton.onclick = function(){
      window.playback.Player.disposeCurrentPlayer();
    };

    var modal = document.querySelector("#modal");
    modal.onclick = function(e){
      if(e.target == modal){
        window.playback.Player.disposeCurrentPlayer();
      }
    };
  }

  load() {
    let placeholders = document.querySelector(".modal-body .player-placeholder");
    window.playback.Player.createAndReplace(placeholders);
    document.querySelector(".modal-body .player-placeholder-content").click();
  }
}
